export const environment = {
  production: false,
  apiUrl: "https://dev-api.barbarafarias.com.br",
  /**
   * Chave **pública** do Mercado Pago (spec 023). É pública por definição — vai
   * no bundle, e o SDK conta com isso. O access token vive só no backend.
   *
   * É ela que permite ao Payment Brick **tokenizar o cartão no navegador**:
   * nenhum dado de cartão passa pela nossa API, que é a garantia estabelecida
   * na spec 014 e preservada aqui.
   *
   * Vazia = o cartão cai no aviso de pagamento indisponível, em vez de quebrar.
   *
   * ⚠️ **Esta chave e o `MP_ACCESS_TOKEN_*` do backend têm de ser da mesma
   * conta.** O token do cartão é emitido pela conta da chave pública que o
   * gerou; cobrar com um access token de outra conta faz o gateway recusar um
   * token que não é dele. Aqui é a conta de teste vendedora `3605074487`, a
   * mesma dos tokens `APP_USR-…-3605074487`.
   */
  mercadoPagoPublicKey: "APP_USR-643f5af3-2a4e-464e-92f7-ba1ccd7424b8",
};
